import { SynchronizationEntity } from '../../synchronization/synchronization-entity';

export enum SynchronizationState {
  Ok = 'Ok',
  Error = 'Error',
  Running = "Running"
}

export interface SynchronizationStatus {
  entity: SynchronizationEntity;
  lastSync: Date;
  synchronizationState: SynchronizationState;
  frequency?: string;
  nextSync?: Date;
  message?: string;
}
